module.exports = __webpack_public_path__ + "img/cloudSun.1f706117.svg";